import styled from "styled-components";
import {
  mediaMinWidth,
  mediaMaxWidth,
} from "../../../utils/mediaQueriesTemplate";

const Wrapper = styled.div`
  width: 100vw;
  height: 60px;
  background-color: #1d2129;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  bottom: ${(props) => (props.scrollDirection === "down" ? "-60px" : "0")};
  left: 0;
  z-index: 6;
  transition: 0.2s ease-in-out;

  &.mobile-search-active {
    display: none;
  }

  ${mediaMinWidth.tablet`
    display: none;
  `}

  ${mediaMaxWidth.tablet`
    &.upScroll {
      bottom: 0px;
    }

    &.downScroll {
      bottom: -60px !important;
    }
  `}
`;

export { Wrapper as default };
